import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";

const ProductDirectSell = ({ listing_id, seller_id }) => {
  const [formData, setFormData] = useState({
    shipping_address: "",
    contact_number: "",
    whatsapp_number: "",
    purchase_note: "",
  });

  const [loading, setLoading] = useState(false); // 👈 Loader State

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const cust_id = localStorage.getItem("cust_id");

  const handleSubmit = async () => {
    const { shipping_address, contact_number, whatsapp_number, purchase_note } = formData;

    if (!shipping_address || !contact_number || !whatsapp_number || !purchase_note) {
      return Swal.fire("Please fill in all fields.", "", "warning");
    }

    const sellData = {
      ...formData,
      listing_id,
      seller_id,
      cust_id,
    };

    setLoading(true); // 🟡 Start Loader  

    try {
      await axios.post(`${baseurl}insertDirectSale`, sellData);

      Swal.fire("Request Submitted!", "The seller will contact you soon.", "success").then(() => {
        window.location.reload();
      });

      setFormData({
        shipping_address: "",
        contact_number: "",
        whatsapp_number: "",
        purchase_note: "",
      });

      document.querySelector(".btn-close").click();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to submit request. Try again later.", "error");
    }

    setLoading(false); // 🔵 Stop Loader
  };

  return (
    <div className="text-start">
      <span
        type="button"
        className="adcas"
        data-bs-toggle="modal"
        data-bs-target="#directSellModal"
      >
        Direct Purchase
      </span>

      <div
        className="modal fade"
        id="directSellModal"
        tabIndex="-1"
        aria-labelledby="directSellModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title" id="directSellModalLabel">
                Direct Purchase Form
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                disabled={loading} // disable close while submitting
              ></button>
            </div>

            <div className="modal-body">
              <div className="mb-2">
                <textarea
                  name="shipping_address"
                  className="form-control"
                  placeholder="Shipping Address"
                  rows="2"
                  value={formData.shipping_address}
                  onChange={handleChange}
                  disabled={loading}
                />
              </div>
              <div className="mb-2">
                <input
                  type="text"
                  name="contact_number"
                  className="form-control"
                  placeholder="Contact Number"
                  value={formData.contact_number}
                  onChange={handleChange}
                  disabled={loading}
                />
              </div>
              <div className="mb-2">
                <input
                  type="text"
                  name="whatsapp_number"
                  className="form-control"
                  placeholder="WhatsApp Number"
                  value={formData.whatsapp_number}
                  onChange={handleChange}
                  disabled={loading}
                />
              </div>
              <div className="mb-2">
                <textarea
                  name="purchase_note"
                  className="form-control"
                  placeholder="Purchase Note"
                  rows="3"
                  value={formData.purchase_note}
                  onChange={handleChange}
                  disabled={loading}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                disabled={loading}
              >
                Close
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}   // prevent multiple clicks
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Submitting...
                  </>
                ) : (
                  "Submit Request"
                )}
              </button>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDirectSell;
